module.exports = __webpack_public_path__ + "img/7c5493d.png";